export default {"src":"/_next/static/media/securityIcon.7529805c.svg","height":31,"width":32,"blurWidth":0,"blurHeight":0};